const ContractingData = [
    {
      id: 1,
      title: "Project Management",
      description: "We oversee and coordinate projects from inception to completion, ensuring efficiency and compliance with industry standards."
    },
    {
      id: 2,
      title: "Manpower Supply",
      description: "Our workforce solutions provide skilled professionals for oil and gas projects, ensuring smooth operations."
    },
    {
      id: 3,
      title: "Equipment Leasing",
      description: "We offer high-quality, well-maintained equipment and machinery for construction and engineering projects."
    },
    {
      id: 4,
      title: "Procurement Services",
      description: "We handle material sourcing, vendor management, and logistics to ensure timely and cost-effective project execution."
    },
    {
      id: 5,
      title: "Site Construction & Maintenance",
      description: "Our team manages on-site construction and maintenance services, ensuring structural integrity and safety compliance."
    }
  ];
  
  export default ContractingData;
  